/*
import {
  hf,
  ht,
  cr,
  a,
  BoxC,
  GridC,
  _cv_60___Ti,
} from 'lib';
*/

import * as BoxC from "./_ccbBoxC";
import * as GridC from "./_cccGridC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as _cv_60___Ti from "./_cv_60___Ti";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnOrnz',
          boxStlz: a(`mb/2`),
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

            cr.c(_cv_60___Ti.L, {
              key: -20,
              sPz: pz.sPz,
              cz: {
                ccd: `rd`,
              }
            }),

            cr.c(_cv_60___Ti.B, {
              key: -40,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'rd7',
                onPrsBack: () => {
                  cr.moveTo({
                    pageName: 'icvHomeK10Rz',
                  });
                }
              }
            })

          ]
        })

      ]
    })
  );
};
